import { useRef } from 'react'
import { useTable } from 'react-table'
import './reacttable.css'
import * as XLSX from 'xlsx'

export const ReactTableMultiExport = ({ data, columns, fileName, sheetName, allStores, enrolledStores, notEnrolledStores, exportColumns }: any) => {
  const tableRef = useRef(null);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns: columns,
    data: data.filter((r: any) => !r.isFooterInfo)
  })

  const handleExport = (dataSet: any[], label: string) => {
    const exportData = dataSet.map(row => {
      const exportRow: any = {};
      exportColumns.forEach((col: any) => {
        exportRow[col.Header] = row[col.accessor];
      });
      return exportRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName || label);
    XLSX.writeFile(workbook, `${fileName || 'Export'}_${label}.xlsx`);
  };

  return (
    <>
    <div className='row'>
      {data && data.length > 0 && data.some((r: any) => !r.isFooterInfo) ? <>
          <div className='exportsection'>
            <button className='btn btn-secondary exportbtn mb-2 btn-sm' onClick={() => handleExport(allStores, 'all')}>Export all stores</button>
            <button className='btn btn-secondary exportbtn mb-2 btn-sm' onClick={() => handleExport(enrolledStores, 'enrolled')}>Export enrolled stores</button>
            <button className='btn btn-secondary exportbtn mb-2 btn-sm' onClick={() => handleExport(notEnrolledStores, 'not_enrolled')}>Export not enrolled stores</button>
          </div>
          <div className='table-responsive'>
            <table {...getTableProps()} ref={tableRef} className='table'>
              <thead>
                {headerGroups.map(headerGroup => (
                  <tr className='table-info' {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                  prepareRow(row)
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => {
                        return <td {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </>
       : <span className='nodataspan'>No data to display</span>}
    </div>
    </>
  )
}